module.exports = __webpack_public_path__ + "img/c07_unittechbowmanchampion_Normal_ua.4f46410b.webp";